import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useRef, useState, useEffect } from 'react';
import EcoTab from 'eco-design/elements/eco-tab';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const Tabs: React.FC = () => {
    const { t } = useLang('dpux.Tabs');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-Tabs');

    const list: any = [
        {
            tabLabel: t('item1_tab'),
            descM: t.rich('item1_desc_M', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            items: [
                {
                    title: t.rich('item1_items1_title', {
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                    sub: [
                        {
                            title: t.rich('item1_items1_sub1_title', {
                                sup: (v: string) => <sup>{v}</sup>,
                            }),
                            desc: t.rich('item1_items1_sub1_desc', {
                                sup: (v: string) => <sup>{v}</sup>,
                            }),
                        },
                        {
                            title: t.rich('item1_items1_sub2_title', {
                                sup: (v: string) => <sup>{v}</sup>,
                            }),
                            desc: t.rich('item1_items1_sub2_desc', {
                                sup: (v: string) => <sup>{v}</sup>,
                            }),
                        },
                    ],
                },
            ],
            pc: ['https://websiteoss.ecoflow.com/upload/image/1760000357244/1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760000420274/1.webp'],
            h5: 'https://websiteoss.ecoflow.com/upload/image/1759044989922/Tab_m1.jpg',
            tabValue: '1',
        },
        {
            tabLabel: t('item2_tab'),
            descM: t.rich('item2_desc_M', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            items: [
                {
                    title: t.rich('item2_items1_title', {
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                    desc: t.rich('item2_items1_desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                },
                {
                    title: t.rich('item2_items2_title', {
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                    desc: t.rich('item2_items2_desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                },
            ],
            desc: t('item2_desc'),
            pc: ['https://websiteoss.ecoflow.com/upload/image/1760000356611/2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760000420518/2.webp'],
            h5: 'https://websiteoss.ecoflow.com/upload/image/1759044991360/Tab_m2.jpg',
            tabValue: '2',
        },
        {
            tabLabel: t('item3_tab'),
            descM: t.rich('item3_desc_M', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            items: [
                {
                    title: t('item3_items1_title'),
                    desc: t.rich('item3_items1_desc', {
                        h: (v: string) => <span className="h">{v}</span>,
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                },
                {
                    title: t('item3_items2_title'),
                    desc: t.rich('item3_items2_desc', {
                        h: (v: string) => <span className="h">{v}</span>,
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                },
            ],
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1760149344284/pc-tab3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760149344799/pc-tab3.webp',
            ],
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760149343978/m_tab3.jpg',
            tabValue: '3',
        },
        {
            tabLabel: t('item4_tab'),
            descM: t.rich('item4_desc_M', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            items: [
                {
                    title: t('item4_items1_title'),
                    desc: t.rich('item4_items1_desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                },
                {
                    title: t('item4_items2_title'),
                    desc: t('item4_items2_desc'),
                },
                {
                    title: t('item4_items3_title'),
                    desc: t.rich('item4_items3_desc', {
                        h: (v: string) => <span className="h">{v}</span>,
                    }),
                },
            ],
            pc: ['https://websiteoss.ecoflow.com/upload/image/1760000357275/4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760000420777/4.webp'],
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760152520955/tab4.jpg',
            tabValue: '4',
        },
        {
            tabLabel: t('item5_tab'),
            descM: t.rich('item5_desc_M', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            items: [
                {
                    title: t.rich('item5_items1_title', {
                        h: (v: string) => <span className="h">{v}</span>,
                        sup: (v: string) => <sup>{v}</sup>,
                    }),
                    desc: '',
                },
            ],
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1760081180542/pc_Smart%20Extreme-Weather%20Protection.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760081181393/pc_Smart.webp',
            ],
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760081180991/m_Smart%20Extreme-Weather%20Protection.jpg',
            tabValue: '5',
        },
    ];

    const [active, setActive] = useState(list[0].tabValue);

    /** 动画 */
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current.querySelector('.title');
        const imgs = sectionRef.current.querySelector('.tab-imgs');
        const tabs = sectionRef.current.querySelector('.eco-tab');

        const screen = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                imgs?.classList.add('enter');
                tabs?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    imgs?.classList.remove('enter');
                    tabs?.classList.remove('enter');
                }
            },
        });

        return () => {
            screen.destroy?.();
        };
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-Tabs GtmModuleData-section`}
            id="delta-pro-ultra-x-Tabs"
            data-section-id={'delta-pro-ultra-x-Tabs'}
            data-section-title={t('title')}
            ref={sectionRef}
        >
            <div className="title ani-1">{t('title')}</div>
            {/* <div className="desc">{t('desc')}</div> */}
            <div className="tab-imgs ani-2">
                {list.map((i, idx) => (
                    <div className={`imgs-item  ${active === i.tabValue ? 'active' : ''}`} key={i.tabValue + idx}>
                        <EcoImg pc={webpOrJpg(i.pc[0], i.pc[1])} h5={i.h5} />
                        <div className={`img-info img-info-${idx}`}>
                            {i.items.map((j, idx2) => (
                                <div className="img-info-item" key={`${idx}-${idx2}`}>
                                    {j.title && <div className="info-title">{j.title}</div>}
                                    {j.desc && <div className="info-desc">{j.desc}</div>}
                                    {j.sub && (
                                        <div className="info-sub">
                                            {j?.sub?.map((k, idx3) => (
                                                <div key={`${idx}-${idx2}-${idx3}`}>
                                                    <div className="info-sub-title">{k.title}</div>
                                                    <div className="info-sub-desc">{k.desc}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <EcoTab className="ani-3" items={list} theme="black" onChange={(i) => setActive(i.tabValue)} />
            <div className="imgs-item-desc-M">{list.find((i) => i.tabValue === active)?.descM}</div>
            <EcoSpace />
        </section>
    );
};

export default Tabs;
